import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SortOptionsService } from './../../services/sort-options.service';

const noop = () => {};

@Component({
  selector: 'app-reactive-text-area',
  templateUrl: './reactive-text-area.component.html',
  styleUrls: ['./reactive-text-area.component.scss'],
})
export class ReactiveTextAreaComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input() fieldName: string = '';
  @Input() customFormControl: UntypedFormControl;
  @Input() patternMatch: string;
  @Input() missingMsg: string;
  @Input() invalidMsg: string;
  @Input() invalidLengthMsg: string;
  @Input() invalidPatternMsg: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() tooltipText: string;
  @Input() required: boolean = false;
  @Input() disabledMsg: string = '';
  @Input() minlength: number;
  @Input() maxlength: number;
  @Input() fieldSize: string = 'small';
  @Input() type = 'text';
  @Input() inputClass = '';
  @Input() min: number;
  @Input() max: number;
  @Input() autocomplete: 'on' | 'off' = 'off';
  @Input() formMargin: number = 3;
  @Input() inputSize: number = 5;
  @Input() labelSize: number = 3;
  @Input() rows: number = 2;
  @Input() showInfoAsTooltip: boolean = true;
  @Input() showFormDivider: boolean = false;
  @Input() compareFieldErrMsg: string;
  @Input() disabled: boolean = false;

  ngOnInit(): void {
    this.invalidMsg = this.invalidMsg || this.label + ' is invalid!';
    this.missingMsg = this.missingMsg || this.label + ' is required!';
    this.placeholder = this.placeholder || this.label;

    if (!this.label) {
      this.inputSize = 12;
      this.labelSize = 0;
    }
  }

  onChangeInputVal(event) {
    this.change.emit(event);
  }
}
